import Styles from './QuizQuestion.module.scss';

// Module imports.
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';

// Component import.
import { useTranslation } from 'components/lib'

export const QuizQuestion = ({ question, questionNumber, onAnswerSelect, selectedAnswers, Results }) => {

    const { t } = useTranslation();
    const { id, question: questionText, options, selectedOption, isCorrect, isAttempted, inference } = question;
    const handleAnswerSelect = (selectedOption, index) => {
        onAnswerSelect(questionNumber - 1, id, selectedOption, question?.question);
    };
    const headerIcon = !isAttempted ? <DoNotDisturbOnIcon fontSize='small' sx={{ mr: '2px' }} />
        : isCorrect ? <CheckCircleIcon fontSize='small' sx={{ mr: '2px' }} />
            : <CancelIcon fontSize='small' sx={{ mr: '2px' }} />

    const headerText = !isAttempted ?
        t('Components.QuizQuestion.header.notAttempted') :
        isCorrect ? t('Components.QuizQuestion.header.correct') :
            t('Components.QuizQuestion.header.incorrect');

    const inferenceText = !isAttempted ?
        t('Components.QuizQuestion.inference.notAttempted') :
        isCorrect ? t('Components.QuizQuestion.inference.correct') :
            inference;
    return (
        <Box sx={{
            padding: 2,
            width: '85%'
        }}>
            <Box width={'100%'} height={'100%'}>
                <Typography>
                    <div className={Styles.question}>
                        {questionText.includes('|||') ? (
                            <>
                                <h3 className={Styles.questionText}>
                                    Q{questionNumber}: {questionText.split('|||')[0]}
                                </h3>
                                <div
                                    className={Styles.codeText}
                                    style={{
                                        whiteSpace: 'pre',
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        padding: '8px',
                                        backgroundColor: 'black',
                                        spellCheck: false,
                                        overflow: 'auto' // Add this line
                                    }}
                                    readOnly
                                >
                                    {questionText.split('|||')[1]}
                                </div>
                            </>
                        ) : (
                            <h3 className={Styles.questionText}>
                                Q{questionNumber}: {questionText}
                            </h3>
                        )}

                        {!Results ? <div className={Styles.gridOptions}>
                            {options.map((option, index) => (
                                <button
                                    key={index}
                                    className={Styles.gridOption}
                                    onClick={() => handleAnswerSelect(option)}
                                    style={{
                                        backgroundColor: selectedAnswers[questionNumber - 1]?.selectedOption === option ? '#4986d6' : '#f2f2f2',
                                        color: selectedAnswers[questionNumber - 1]?.selectedOption === option ? '#ffffff' : '#000000'
                                    }}
                                >
                                    {option}
                                </button>
                            ))}
                        </div> : <div className={Styles.gridOptions}>
                            {options.map((option, index) => {
                                const isSelected = (option === selectedOption);
                                return (
                                    <button
                                        key={index}
                                        className={Styles.gridOption}
                                        style={{
                                            backgroundColor: isSelected && isCorrect ? '#18af89' : isSelected ? '#dc6262' : '#f2f2f2',
                                            color: isSelected && isCorrect ? '#fff' : isSelected ? '#fff' : '#000'
                                        }}
                                    >
                                        {option}
                                    </button>
                                )
                            })}
                        </div>}
                    </div>
                    {Results &&
                        <div id='inferenceContainer'
                            className={Styles.inferenceContainer}
                            style={{
                                backgroundColor: !isAttempted ? '#f5f5f5' : isCorrect ? '#f4faf8' : '#fef4f5',
                            }}
                        >
                            <h3>
                                {headerIcon}{headerText}
                            </h3>
                            <p>{inferenceText}</p>
                        </div>}
                </Typography>
            </Box>
        </Box>
    );
};